import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from '@/router/routes'
import { jwtService } from '@/services/jwt'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes,
})

router.beforeEach((to, from, next) => {
  if (to.name === 'authLogin' || jwtService.getToken()) return next()
  return next({ name: 'authLogin' })
})
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
